React = require('react')
trackUe = require('debug/trackUe')

{ forTemplate } = require('common/lib/util/i18n')
format = forTemplate('header_notification_list_menu')

module.exports = class NotificationActions extends React.Component
  displayName: 'NotificationActions'

  render: ->
    {
      markAllRead,
      toggleVisibilityFilter,
      totalUnreadNotifications,
      filteredByUnread
    } = @props

    React.createElement('div', { className: 'notification-actions' },
      React.createElement('button', {
        className: 'visibility-filter quiet unstyled-button',
        onClick: toggleVisibilityFilter
      },
        if filteredByUnread
          format('visibility-filter-all')
        else
          format('visibility-filter-unread')
      )
      if totalUnreadNotifications > 0
        React.createElement('button', {
          className: 'mark-all-read quiet unstyled-button'
          onClick: =>
            trackUe(
              'header'
              'marks as read'
              'all notifications'
              'on notifications menu'
              ''
              'by clicking mark all as read button'
            )
            markAllRead()
        },
          format('mark-all-as-read')
        )
    )



// WEBPACK FOOTER //
// ./app/scripts/views/notification/notification-actions.coffee